import type { AccentHue } from "@repo/fika-design-system/color"
import type { IconName } from "@repo/fika-design-system/icon"
import { A } from "@solidjs/router"
import { For, Show } from "solid-js"
import { Icon } from "./icon"
import { tabIconClass, tabLinkRecipe, tabsContainerClass } from "./tabs.css"

export type Tab = {
  label: string
  href: string
  iconName?: IconName
}

type TabsProps = {
  tabs: Tab[]
  hue: AccentHue
  activeHref: string
}

export function Tabs(props: TabsProps) {
  return (
    <nav class={tabsContainerClass}>
      <For each={props.tabs}>
        {tab => {
          const isActive = () => tab.href === props.activeHref
          return (
            <A
              href={tab.href}
              class={tabLinkRecipe({
                active: isActive(),
                hue: props.hue,
              })}
            >
              <Show when={tab.iconName}>
                {iconName => (
                  <Icon name={iconName()} size="18" class={tabIconClass} />
                )}
              </Show>
              {tab.label}
            </A>
          )
        }}
      </For>
    </nav>
  )
}
